import axiosClient from './axiosClient';
export default {
  list: (params) => axiosClient.get('/contratti', { params }),
  get: (id) => axiosClient.get(`/contratti/${id}`),
  renew: (id) => axiosClient.post(`/contratti/renewcontract/${id}`),
  create: (data) => axiosClient.post('/contratti', data),
  update: (id, data) => axiosClient.put(`/contratti/${id}`, data),
  delete: (id) => axiosClient.delete(`/contratti/${id}`),
  annulla: (id) => axiosClient.post(`/contratti/annulla/${id}`),
  updateDuration: (id, years) => axiosClient.put(`/contratti/update-duration/${id}`, null, { params: { years } }),
};